import { EditOutlined } from '@ant-design/icons';
import { Select as BaseSelect } from 'antd';
import { observer } from 'mobx-react';
import React, { useState } from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';
import { includesNoCase } from 'utils/String';

const CREATE_OPTION_VALUE = 'create';

const { Option } = BaseSelect;

const Select = styled(BaseSelect)`
  width: 200px;
`;

const EditIcon = styled(EditOutlined)`
  margin-right: 4px;
`;

function FiltersSetsDropdown() {
  const [search, setSearch] = useState('');

  const filterManager = store.creative?.ads.filter;

  const handleSelectionOnChange = (value: unknown) => {
    if (!filterManager) return;

    if (!value) {
      filterManager.resetToScratch();
      setSearch('');
    } else if (typeof value === 'string') {
      if (value === CREATE_OPTION_VALUE) {
        filterManager.openNewFilterModal(search);
      } else {
        filterManager.setCurrentByName(value);
      }
    } else {
      console.warn(
        `[FiltersSetsDropdown#handleSelectionOnChange] Unexpected value type (${typeof value}):`,
        value
      );
    }
  };

  // Undefined leaves the Select on its placeholder, which is how "no saved
  // filter selected" is shown. The scratch filter has a name, but it is a
  // debug label rather than something to display.
  const value =
    filterManager && !filterManager.isScratch
      ? filterManager.current.name
      : undefined;

  const showCreateOption =
    search || filterManager?.saved.properties.length === 0;

  return (
    <Select
      allowClear
      filterOption={() => true}
      notFoundContent={null}
      onChange={handleSelectionOnChange}
      onSearch={(value) => setSearch(value)}
      optionFilterProp="children"
      placeholder="Select a filter"
      showSearch
      value={value}
    >
      {showCreateOption && (
        <Option
          key="create"
          value={CREATE_OPTION_VALUE}
          data-testid="FilterSetsDropdown_create"
        >
          <EditIcon />
          Create New
        </Option>
      )}

      {filterManager &&
        filterManager.saved.properties
          .filter((property) => includesNoCase(property.name, search))
          .map((set) => (
            <Option
              key={`filterSetDropdown.option.${set.name}`}
              value={set.name}
            >
              {set.name}
            </Option>
          ))}
    </Select>
  );
}

export default observer(FiltersSetsDropdown);
